export var LOREM_IPSUM = 'COMMAND_LOREM_IPSUM';
export var TODAY = 'COMMAND_TODAY';
export default {
  LOREM_IPSUM: LOREM_IPSUM,
  TODAY: TODAY
};